import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, TagIcon, AwardIcon, SmileIcon, ZapIcon, ClockIcon, TimerIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const ITEMS = [{
  icon: SparklesIcon,
  title: 'Armada Bersih & Terawat'
}, {
  icon: TagIcon,
  title: 'Harga Kompetitif'
}, {
  icon: AwardIcon,
  title: 'Driver Berpengalaman'
}, {
  icon: SmileIcon,
  title: 'Pelayanan Ramah & Profesional'
}, {
  icon: ZapIcon,
  title: 'Proses Booking Cepat'
}, {
  icon: ClockIcon,
  title: 'Siap Melayani 24 Jam'
}, {
  icon: TimerIcon,
  title: 'Tepat Waktu'
}, {
  icon: ShieldCheckIcon,
  title: 'Kendaraan Selalu Prima'
}];
export function Advantages() {
  return <section className="relative bg-ink-soft py-24" data-id="element-32" data-mp="2tju714urf1a6">
      <div className="mx-auto max-w-7xl px-5" data-id="element-33" data-mp="25vkqoigbf5qf">
        <SectionHeading eyebrow="Keunggulan Kami" title={<>Kenapa Memilih <span className="text-gold-gradient" data-id="element-35" data-mp="20vybi3gxffez">Kami</span></>} subtitle="Komitmen kami adalah memberikan pengalaman perjalanan yang aman, nyaman, dan berkelas." data-id="element-34" data-mp="25u9mwimvdxzb" />

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-36" data-mp="3lljxqi6eyy05">
          {ITEMS.map((it, i) => {
          const Icon = it.icon;
          return <motion.div key={it.title} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.45,
            delay: i % 4 * 0.08
          }} className="flex items-center gap-4 rounded-2xl border border-white/5 bg-ink-card p-5 transition-colors hover:border-gold/40" data-id="element-37" data-mp="3uef5pjn9n7tm" data-mpi={i}>
                <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full gold-border text-gold" data-id="element-38" data-mp="3bpqmd24flajy">
                  <Icon className="h-5 w-5" data-id="element-39" data-mp="m0y3n7zhhokv" />
                </div>
                <span className="text-sm font-medium text-white/85" data-id="element-40" data-mp="qwwud28abiog">{it.title}</span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}